var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 480",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Card6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "50%",
    x2: "50%",
    y2: "93.187%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4FD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 480,
    display: "none",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "background",
    transform: "rotate(180 378.95 225.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    transform: "rotate(180 374.15 182.4)",
    d: "m748.31 364.8c0-255.72-118.44-364.8-374.15-364.8-255.72 0-374.15 109.08-374.15 364.8z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 694.31,
    cy: 169.2,
    r: 10.8,
    fill: "#e5eeff",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    transform: "rotate(150 32.108 194.4)",
    d: "m23.46 197.27c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.416-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#c4d2ed",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.71,
    cy: 73.6,
    r: 14.4,
    fill: "#f3f6fd"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(163 585.91 76.2)",
    d: "m580.37 78.532c-1.9825-6.3548 6.1953-11.464 10.284-5.7318 3.7172 5.2334-2.4781 11.339-7.8061 8.5977-2.1064-1.1214-3.965 2.1183-1.8586 3.2397 9.0451 4.735 18.958-5.981 12.391-14.33-6.6909-8.5977-19.701-0.87223-16.603 9.2207 0.74343 2.2429 4.3367 1.3706 3.5933-0.99684z",
    fill: "#c7d5ee",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15 624.4 306.38)",
    d: "m614.71 310.46c-3.4694-11.121 10.842-20.061 17.997-10.031 6.5051 9.1584-4.3367 19.843-13.661 15.046-3.6862-1.9625-6.9387 3.707-3.2525 5.6695 15.829 8.2862 33.176-10.467 21.684-25.077-11.709-15.046-34.477-1.5264-29.056 16.136 1.301 3.925 7.5892 2.3986 6.2882-1.7445z",
    fill: "#e7eef9"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(30 652.31 76.8)",
    d: "m643.66 79.673c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.415-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50374 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#f4f7fe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(251 140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 131,
    r: 131,
    fill: "#fff",
    stroke: "#5374A5",
    strokeWidth: 7.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m162 133.85-13.16-4.372v-1.2765c7.5091-5.522 12.397-14.426 12.397-24.457v-33.481c0-2.0787-1.6814-3.7644-3.7547-3.7644h-34.964c-11.999 0-21.762 9.787-21.762 21.817v15.428c0 10.031 4.8872 18.935 12.396 24.456v1.2765l-13.16 4.372c-14.951 4.9667-24.996 18.914-24.996 34.705v23.181c0 2.0787 1.6814 3.7644 3.7547 3.7644h104.49c2.0734 0 3.7547-1.6857 3.7547-3.7644v-23.181c0-15.79-10.045-29.738-24.996-34.704zm-39.483-59.822h31.21v18.998c-2.6745 1.1218-5.5686 1.7177-8.4883 1.7177-6.8531 0-13.193-3.1275-17.392-8.5802-0.71115-0.92303-1.8083-1.464-2.9719-1.464-1.1632 0-2.2607 0.54094-2.9719 1.4636-3.4198 4.4405-8.2585 7.3375-13.638 8.261v-6.1077c0-7.8785 6.3932-14.288 14.252-14.288zm-14.252 29.716v-1.7162c6.2697-0.79391 12.056-3.5592 16.609-7.9429 5.45 5.2472 12.664 8.1868 20.364 8.1868 2.8806 0 5.7451-0.42952 8.4883-1.2543v2.7265c0 12.566-10.197 22.789-22.731 22.789-12.534 0-22.73-10.223-22.73-22.789zm32.794 28.586v5.4072c0 5.5626-4.5139 10.089-10.063 10.089-5.5487 0-10.063-4.5255-10.063-10.089v-5.4068c3.1498 1.1176 6.5351 1.7324 10.062 1.7324 3.5276 0 6.9132-0.61472 10.063-1.7327zm28.236 55.641v-20.664c0-2.0787-1.6814-3.7644-3.7547-3.7644-2.0734 0-3.7547 1.6857-3.7547 3.7644v20.664h-61.578v-20.664c0-2.0787-1.6814-3.7644-3.7547-3.7644-2.0734 0-3.7547 1.6857-3.7547 3.7644v20.664h-10.193v-19.416c0-12.54 7.9766-23.614 19.848-27.558l11.07-3.6782v0.4186c0 9.7144 7.8827 17.617 17.572 17.617s17.572-7.903 17.572-17.617v-0.4186l11.069 3.6778c11.872 3.9443 19.849 15.019 19.849 27.558v19.417h-10.191z",
    fill: "#5374A5",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 84)",
    fill: "#fff",
    stroke: "#5374A5",
    strokeWidth: 7.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    transform: "translate(75.5 65.5) scale(-1 1) translate(-75.5 -65.5)",
    d: "m25.915 0h99.169c14.313-2.6292e-15 25.915 11.603 25.915 25.915v53.425c0 14.257-11.516 25.837-25.773 25.915l-11.107 0.06088-23.561 21.211c-1.4505 1.3058-3.685 1.1886-4.9908-0.26196-0.47511-0.52774-0.7802-1.1864-0.87553-1.89l-2.5818-19.059-56.259-0.1385c-14.288-0.035175-25.851-11.627-25.851-25.915v-53.347c1.7999e-15 -14.313 11.603-25.915 25.915-25.915z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m283.01 154.38 26.489-26.489c-2.1884-7.1837-0.45041-15.306 5.2306-20.986 6.2841-6.2842 15.552-7.7347 23.234-4.3884l-9.7297 9.7297c-1.308 1.308-1.308 3.429 0 4.737l6.1149 6.1137c1.308 1.308 3.429 1.308 4.737 0l9.7297-9.7297c3.3463 7.6825 1.8958 16.952-4.3883 23.234-5.6798 5.6798-13.804 7.4191-20.986 5.2294l-26.49 26.49c-3.2598 3.261-8.5464 3.261-11.806 0l-2.135-2.135c-3.2598-3.2598-3.2598-8.5451 0-11.806",
    fill: "#79A3FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportImg);
export default __webpack_public_path__ + "static/media/Support_img.6858226300be5849a57ca15787979363.svg";
export { ForwardRef as ReactComponent };